import { useState, useEffect } from 'react';
import api from '../api';

export default function useBacklogHistory({ showToast, projectId, showHistory }) {
  const [historySprints, setHistorySprints] = useState([]);
  const [loadingHistory, setLoadingHistory] = useState(false);
  const [expandedSprints, setExpandedSprints] = useState({});

  useEffect(() => {
    if (!showHistory) return;
    const loadHistory = async () => {
      setLoadingHistory(true);
      try {
        const closed = await api.getClosedSprints(projectId);
        const allItems = [];
        for (const s of closed) {
          const sItems = await api.getSprintItems(s.id);
          if (sItems.length > 0) {
            allItems.push({ sprint: s, items: sItems });
          }
        }
        setHistorySprints(allItems);
      } catch (err) {
        showToast(err.message || 'Failed to load history', 'error');
      } finally {
        setLoadingHistory(false);
      }
    };
    loadHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showHistory]);

  const toggleSprint = (id) => {
    setExpandedSprints((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return {
    historySprints,
    loadingHistory,
    expandedSprints,
    toggleSprint,
  };
}
